import React from 'react';
import { IonRow, IonCol, IonItemDivider, IonText, IonIcon, IonButton } from '@ionic/react';
import { checkmarkDone, checkmark, warning } from 'ionicons/icons';
import Params from './Params';

interface ContainerProps {
    result: number;
    params: any;
    literales: any;
}
const Resultado: React.FC<ContainerProps> = ({ result, params,literales }) => {
    return (
        <>
            <Params params={params} literales={literales} />
            <IonRow key="alert0" className="paddingh20 mt2 textblack  mx2">
                <IonCol>
                    {result && <IonText className="w100 textblack mb1"> {literales.textos[result]}</IonText>}
                </IonCol>
            </IonRow>
            {params.fe === 3 && <IonRow key="alert1" className="textblack paddingh20 mt2  mx2">
                    <IonCol>
                        <IonText>{literales.otrostextos.fedesconocida}</IonText>
                    </IonCol>
                </IonRow>}
            {(result > 0 && result < 23) && <>
                <IonRow key="obj" className="paddingh20 mt1 mb1 ">
                    <IonCol>
                        <IonText className="textblack mb2 w100">{literales.otrostextos.objetivos}</IonText>
                    </IonCol>
                </IonRow>
                <IonRow key="orden" className="paddingh20 paddingh20 mt1 mb1 ">
                    <IonCol>
                        <IonText className="textstrong mb2 w100">{literales.otrostextos.orden}:</IonText>
                    </IonCol>
                </IonRow></>}
            <IonRow key="combinaciones" className="paddingh20 mt1 mb3 ">
                {result && literales.combinaciones[result].map((item: any, index: number) => (
                    <IonCol key={"col" + result + index} size="3" className='padding0'>
                        {literales.etapas_flecha[item].color === "red" &&
                            <IonButton color="light" expand="full" size="small"  className="f1 padding0"><IonIcon className="  f1 rojo" icon={warning}></IonIcon><IonText key="subtitle" className="f1 textrojo textstrong" style={{ fontSize: "0.85em" }}>{literales.etapas_flecha[item].text}</IonText></IonButton>
                        }
                        {literales.etapas_flecha[item].color === "amarillo" &&
                            <IonButton color="light" expand="full" size="small" className="f1 padding0"><IonIcon className="  f1 amarillo" icon={checkmark}></IonIcon><IonText key="subtitle" className="f1 textrojo textstrong" style={{ fontSize: "0.85em" }}>{literales.etapas_flecha[item].text}</IonText></IonButton>
                        }
                        {literales.etapas_flecha[item].color === "verde" &&
                            <IonButton color="light" expand="full" size="small" className="f1 padding0"><IonIcon className="  f1 verde" icon={checkmarkDone}></IonIcon><IonText key="subtitle" className="f1 textrojo textstrong" style={{ fontSize: "0.85em" }}>{literales.etapas_flecha[item].text}</IonText></IonButton>
                        }
                    </IonCol>
                ))}
            </IonRow>
            {result && literales.combinaciones[result].map((item: any) => (
                <>
                    <IonRow key={"rowtitle" + item} className="paddingh20" >
                        <IonCol size="12">
                            <IonText key="title" className="w100 f3 mb1 mt2">
                                {literales.etapas_flecha[item].color === "red" && <IonIcon className="f1 pr1 rojo" icon={warning}></IonIcon>}
                                {literales.etapas_flecha[item].color === "amarillo" && <IonIcon className="f1 pr1 amarillo" icon={checkmark}></IonIcon>}
                                {literales.etapas_flecha[item].color === "verde" && <IonIcon className="f1 pr1  verde" icon={checkmarkDone}></IonIcon>}
                                {literales.etapas_flecha[item].text}
                                {literales.etapas_flecha[item].text2 && <IonText className="f1 "> ({literales.etapas_flecha[item].text2})</IonText>}
                            </IonText>
                        </IonCol>
                    </IonRow>
                    {literales.etapas_alertas[item].map((element: any) => <IonRow key={element} className="paddingh20"><IonCol size="12"><IonText className="w100 f1 mb2 textblack text-left">{element}</IonText></IonCol></IonRow>)}
                </>
            ))}
            <IonItemDivider></IonItemDivider>
            <IonRow key="DIU1" className="paddingh20 pt2">
                        <IonCol size="12">
                            <IonText className="f1 mt2 w100 textstrong" ><br />{literales.otrostextos.opcionaldui}</IonText>
                        </IonCol>
            </IonRow>
            <IonRow key="DIU2" className='paddingh20'>
                        <IonCol size="12">
                            <IonText key="title" className="w100 f3 mb1 mt2">
            {((result > 0 && result < 10) || result === 23) && <IonIcon className="f1 pr1 amarillo" icon={checkmark}></IonIcon>}
            {((result > 0 && result > 10 && result < 23) || result===24) && <IonIcon className="f1 pr1 verde" icon={checkmarkDone}></IonIcon>}            
                                DIU
                            </IonText>
                        </IonCol>
                    </IonRow>
            {((result > 0 && result < 10) || result === 23) && 
                    <IonRow key="DIU3" className='paddingh20'>
                        <IonCol size="12">
                            <IonText className="w100 f1 mb2 textblack text-left">{literales.otrostextos.duifurosemida}</IonText>
                        </IonCol>
                    </IonRow>}

            <IonItemDivider></IonItemDivider>
            <IonRow key="ley1" className='paddingh20 pt2'>
                <IonCol size="12">
                    <IonText class="f1  textstrong">{literales.otrostextos.leyenda}: </IonText>
                </IonCol>
            </IonRow>
            <IonRow key="ley2" className='paddingh20'>
                <IonCol size="12">
                    <IonButton color="light" size="small" className="f0"><IonIcon className=" pr1  verde" icon={checkmarkDone}></IonIcon> 
                    {literales.otrostextos.indicado}                    
                    </IonButton>
                </IonCol>
            </IonRow>
            <IonRow key="ley3" className='paddingh20'>
                <IonCol size="12">
                    <IonButton color="light" size="small" className="f0"><IonIcon className=" pr1 amarillo" icon={checkmark}></IonIcon> 
                    {literales.otrostextos.vigilancia}
                    </IonButton>
                </IonCol>
            </IonRow>
            <IonRow key="ley4" className='paddingh20'>
                <IonCol size="12">
                    <IonButton color="light" size="small" className="f0"><IonIcon className=" pr1 rojo" icon={warning}></IonIcon> 
                    {literales.otrostextos.precaucion}
                    </IonButton>
                </IonCol>
            </IonRow>
            <IonRow key="ley5" className='paddingh20'>
                <IonCol size="12">
                    <IonText className="f1 textblack mt2 w100" >
                        {literales.otrostextos.disclaimerpie}
                    </IonText>
                </IonCol>
            </IonRow>
        </>
    );
};

export default Resultado;
